
import { useNavigate } from 'react-router-dom';
import { useToast } from '@/hooks/use-toast';

export const useKpiCardInteractions = () => {
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleCardClick = (id: string, editMode: boolean) => {
    if (!editMode) {
      navigate(`/energy/kpi/${id}`);
    }
  };

  return {
    handleCardClick
  };
};

export default useKpiCardInteractions;
